import { render, staticRenderFns } from "./VerOrdem.vue?vue&type=template&id=01f74324&"
import script from "./VerOrdem.vue?vue&type=script&lang=js&"
export * from "./VerOrdem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports